// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/fdf67e8fdc00b882eb07.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"413eec3fbb2038093c26","137":"ea373e6fef8e6122b9e9","138":"edbdded98b4e991c649f"}[chunkId] + ".chunk.js";
};